import { BaseSopOperation } from "./_Base";
import { Color } from "three";
import { InputCloneMode } from "../../poly/InputCloneMode";
import { Reflector } from "../../../modules/core/objects/Reflector";
import { Vector3 } from "three";
import { TransformResetSopOperation, TRANSFORM_RESET_MODES, TransformResetMode } from "./TransformReset";
export class ReflectorSopOperation extends BaseSopOperation {
  static type() {
    return "reflector";
  }
  async cook(inputCoreGroups, params) {
    var _a;
    this._transformResetOptions = this._transformResetOptions || new TransformResetSopOperation(this._scene);
    const transformResetMode = TRANSFORM_RESET_MODES.indexOf(TransformResetMode.PROMOTE_GEO_TO_OBJECT);
    const inputCoreGroup = this._transformResetOptions.cook(inputCoreGroups, { mode: transformResetMode });
    const reflectors = [];
    const renderer = (_a = this._node) == null ? void 0 : _a.scene().renderersRegister.lastRegisteredRenderer();
    const objects = inputCoreGroup.objectsWithGeo();
    for (let object of objects) {
      Reflector.rotateGeometry(object.geometry, params.direction);
      const reflector = new Reflector(object.geometry, {
        clipBias: params.clipBias,
        renderer,
        scene: this.scene().threejsScene(),
        pixelRatio: params.pixelRatio,
        multisamples: params.multisamples,
        color: params.color,
        opacity: params.opacity,
        active: params.active,
        tblur: params.tblur,
        blur: params.blur,
        verticalBlurMult: params.verticalBlurMult,
        tblur2: params.tblur2,
        blur2: params.blur2,
        verticalBlur2Mult: params.verticalBlur2Mult
      });
      reflector.matrixAutoUpdate = false;
      object.matrix.decompose(object.position, object.quaternion, object.scale);
      reflector.position.copy(object.position);
      reflector.rotation.copy(object.rotation);
      reflector.scale.copy(object.scale);
      reflector.updateMatrix();
      Reflector.compensateGeometryRotation(reflector, params.direction);
      reflectors.push(reflector);
    }
    return this.createCoreGroupFromObjects(reflectors);
  }
}
ReflectorSopOperation.DEFAULT_PARAMS = {
  direction: new Vector3(0, 1, 0),
  active: true,
  clipBias: 3e-3,
  color: new Color(1, 1, 1),
  opacity: 1,
  pixelRatio: 1,
  multisamples: 4,
  tblur: false,
  blur: 1,
  verticalBlurMult: 1,
  tblur2: false,
  blur2: 1,
  verticalBlur2Mult: 1
};
ReflectorSopOperation.INPUT_CLONED_STATE = InputCloneMode.ALWAYS;
